module.exports = __webpack_public_path__ + "static/media/editor_admin.0c644130.svg";